/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vast_Weak_Newt_JumpInputs */

const en_vast_weak_newt_jump = /** @type {(inputs: Vast_Weak_Newt_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inaktiv`)
};

const de_vast_weak_newt_jump = /** @type {(inputs: Vast_Weak_Newt_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inaktiv`)
};

/**
* | output |
* | --- |
* | "Inaktiv" |
*
* @param {Vast_Weak_Newt_JumpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const vast_weak_newt_jump = /** @type {((inputs?: Vast_Weak_Newt_JumpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vast_Weak_Newt_JumpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vast_weak_newt_jump(inputs)
	return de_vast_weak_newt_jump(inputs)
});